// /lib/errors/ApiError.ts
export class ApiError extends Error {
  public httpStatus: number;
  public code?: string;

  constructor(httpStatus: number, message: string, code?: string) {
    super(message);
    this.httpStatus = httpStatus;
    this.code = code; 
    Object.setPrototypeOf(this, ApiError.prototype);
    this.stack = undefined;
  }
}

